/**
 * Format phone number for display. Ensures a leading + if the number has digits.
 * Does not force any country code; displays the value as stored (with + prefix if missing).
 * @param {string|number} phoneNumber
 * @returns {string}
 */
export function formatPhoneNumber(phoneNumber) {
  const s = String(phoneNumber ?? "").trim();
  if (!s) return "NA";
  if (s.startsWith("+")) return s;
  // If it looks like digits (with optional spaces/dashes), prepend +
  if (/^[\d\s-]+$/.test(s)) return `+${s.replace(/[\s-]/g, "")}`;
  return s;
}
